import { IModalTypes, IUseModal, useModal } from "@Utils";

/**
 * TODO: phase this out as we implement the mui modal component
 */
export const useOpenEventPageModal = () => {
    const { openModal, modalInfo } = useModal();

    const handleOpen = (
        modalTypeArg: IModalTypes,
        openModalArgs?: IUseModal.IOpenModalProps
    ): void => {
        openModal(modalTypeArg, {
            ...openModalArgs,
            modalProps: {
                ...(openModalArgs?.modalProps || {}),
                baseModalArgs: modalInfo.modalProps,
            },
        });
    };

    return { handleOpen };
};
